<div class="sidebar-wrapper">
  <div class="sidebar-logo">
    <!--  <a routerLink="/"><img [src]="'assets/img/Logo.svg'"></a>-->
    <a id="minimizeSidebar" (click)="toggleSidebar()" >
      @if (!isMinimized) {
        <img height="49" width="191" [src]="'assets/img/logo.png'" />
      }
      @if (isMinimized) {
        <img height="26" [src]="'data:image/webp;base64,UklGRlwCAABXRUJQVlA4WAoAAAAQAAAAMwAAMwAAQUxQSHgBAAARkEPbtqk9+zc6x7atykmlyrZVqUtl27Zt27Zt29nFw90nLiNiAvAfM+fY6/T++Pjm9dv3764O+Qmi19N9gVkVKr9adaHWqAO1i21yUzzC5qTqi0lWyotZ9NP1t9ikO2xxW0eLTwa5DL7JpiTC8KOqMkxfq2B7yeHHta1T+jWqkArjBWFGF0NwFIDMW3T1Q3TYyLC1gWWcrcqxI4TjvXqrSHbVtKTxTEX0NhrPjxAk/6Bxbyg/kby1r8FR3QrFHpLMCLTWfRVUJ8mHAKB7JDjv2epZLZvglkTvFk922V63Fj7nPIhfL8rvNsKHAJrmAHJvlLR2m+dXDHEr4U2dJugoG49zmXwA9HzqcB/uw/3YbyPCll3ieVG/fOmSpQpD2CKA8aEAtLvyDvqkoAkuwAEDnA/gQZcstKgZxM9FwvUyweEgckCo/cxtEfMtBO9lC0EeMmH4AQG1SJY02OjA58V8ppDsrKtE91me1yS76J4IyCrITJKddP/2VlA4IL4AAACwBwCdASo0ADQAPokeolElISUlGPCgEQlpAAgQBEcymfHQRiu3plBTuG1JuPoi1eMXn0Rg9aJzu4/eocGjonLuOaMYLZ6AAP78/wUJRtClRBwRmVt8EfnDTC/wDNEZF7GFv5ZV4LNdh2mRSFoAd5qdgHzfxOXmERb9DPlhuRO3LbizQcjInOSCxs1umATgnIgW4aSoOIzyaZbcoPuElgbenqd2leCxmWW++cZimEWhsH2Cz5lHVNt64IqYgAAA'" />
      }
    </a>

  </div>
  <ul class="nav">
    @for (menuItem of menuItems; track menuItem) {
      @if (menuItem.display) {
        <li class="nav-item" [class.active]="activeRoute.startsWith('/'+menuItem.activePath) && !menuItem.children">
          <a 
            [routerLink]="menuItem.children ? null : menuItem.path"
            [title]="menuItem.title" 
            (click)="toggleMenu(menuItem,$event); closeSidebarOnMobile()"
            class="nav-link"
          >
            <i *ngIf="menuItem.icon" class="nav-icon" class="{{menuItem.class}}" title="{{ menuItem.title }} icon"></i>
            <i *ngIf="!menuItem.icon" class="nav-icon" class="{{menuItem.class}}"  title="{{ menuItem.title }} icon"></i>
            <p [class.new-feature]="newFeatureFlag.includes(menuItem.title)" [class.has-submenu]="newFeatureFlag.includes(menuItem.title)">
              <span>{{menuItem.title}}</span>
              <i *ngIf="newFeatureFlag.includes(menuItem.title)"></i>
            </p>
            @if(menuItem.children && !isMinimized){
              <span class="ik ik-chevron-down submenu-arrow"
                 [class.rotate]="expandedMenus[menuItem.title]"></span>
            }
          </a>
          @if (menuItem.children && expandedMenus[menuItem.title]) {
            <ul class="sub-nav"  [ngClass]="isMinimized ? 'hide' : ''">
              @for (subItem of menuItem.children; track subItem) {
              <li class="nav-item" [class.active]="activeRoute.startsWith('/'+subItem.activePath)">
                <a class="nav-link" [routerLink]="subItem.path" [class.active]="activeRoute.startsWith('/'+subItem.activePath)">
                  <i *ngIf="subItem.class" [ngClass]="['nav-icon', subItem.class]" title="{{ subItem.title }} icon"></i>
                  <p [class.new-feature]="newFeatureFlag.includes(subItem.title)">
                    <span>{{ subItem.title }}</span>
                    <i *ngIf="newFeatureFlag.includes(subItem.title)"></i>
                  </p>
                </a>
              </li>
              }
            </ul>
            }
        </li>
      }
    }
  </ul>
</div>